import { useState, useEffect } from 'preact/hooks'
import { createRef } from 'preact/compat'
import ErrorValidation from './personalized/error-validation'
import { __ } from '../../locales'

const SearchSelect = ({
  value = null,
  options,
  onChange,
  title,
  placeholder = __('inputs.global.type_something_placeholder'),
  onRemove = () => {},
  multiple = false,
  onAutocompleteSearch = () => {},
  required,
  disabled,
}) => {
    const [search, changeSearch] = useState('');
    const [isFocused, setFocused] = useState(false);
    let wrapperSelect = createRef();
    useEffect(() => {
        const handleOutsideClick = ev => {
            if (wrapperSelect && !wrapperSelect.contains(ev.target)) {
                setFocused(false);
                changeSearch('');
            }
        };
        document.addEventListener('mousedown', handleOutsideClick);
        return () => {
            document.removeEventListener('mousedown', handleOutsideClick);
        }
    }, [wrapperSelect, multiple]);

    const getOptions = () => {
        if (multiple) {
            return options.filter(
                option =>
                    option.label.toLowerCase().includes(search.toLocaleLowerCase())
                    && !value?.find?.(item => item.value === option.value)
            )
        }
        return options
    };

    return (
        <div className={'input-component'}>
            <div className={'d-flex'}>
                <div className={'input-component'} style={{ width: '100%' }}>
                    <label>{title}:</label>
                    <div className="list-wrapper">
                        <input
                            disabled={disabled}
                            type="text"
                            value={!isFocused && !multiple && value ? value.label : search}
                            onInput={ev => {
                                changeSearch(ev.target.value);
                                onAutocompleteSearch(ev.target.value);
                            }}
                            className={`form-control ${required && !value ? 'error' : ''} `}
                            placeholder={(!multiple && value) || value?.length === 1 ? value?.[0]?.label : placeholder}
                            onFocus={() => {
                                setFocused(true)
                                onAutocompleteSearch(search);
                            }}
                        />
                        <div
                            className={'list-group'}
                            style={{ display: isFocused ? 'block' : 'none' }}
                            ref={ref => wrapperSelect = ref}
                        >
                            {
                                getOptions().map((filteredItem, index) => (
                                    <div
                                        key={`${index}-${filteredItem.value}`}
                                        className={'list-group-item'}
                                        onClick={() => {
                                            onChange(filteredItem);
                                            if (!multiple) {
                                                setFocused(false)
                                            }
                                        }}>{filteredItem.label}</div>
                                ))
                            }
                        </div>
                    </div>
                </div>
                {multiple && value?.length > 1 ? (
                    <div className="list-group list-group-flush selected-items-list">
                        {
                            value.map(elem => (
                                <div className="list-group-item">
                                    {elem.label}
                                    {!disabled && <span onClick={() => onRemove(elem.value)}>X</span>}
                                </div>
                            ))
                        }
                    </div>
                ) : null}
            </div>
            {required && (Array.isArray(value) && !value?.length) || (required && !value) ? (
                <ErrorValidation />
            ) : null}
        </div>
    );
};

export default SearchSelect;

